import { AdgroupFormData, CampaignFormData, CreativeConfig } from '@tt4b/ttam-enums';
import { useAllowlist, useStdAdgroupIs } from '@tt4b/ttam-hooks';
import { Ref, computed } from '@vue/composition-api';

export function usePropsVisible(options: {
  campaignFormData: Ref<CampaignFormData>;
  adgroupFormData: Ref<AdgroupFormData>;
}) {
  const { campaignFormData, adgroupFormData } = options;
  const { isSmartCreativeWhite } = useAllowlist();
  const { isProductFromCatalog, isProductProspective } = useStdAdgroupIs({
    campaignFormData,
    adgroupFormData,
  });
  // 白名单 & non shop & 非重

  const visible = computed(
    () => isSmartCreativeWhite.value && isProductFromCatalog.value && isProductProspective.value
  );
  return {
    visible,
  };
}

export function usePropsDisabled(options: { creativeConfig: Ref<CreativeConfig> }) {
  const { creativeConfig } = options;
  const disabled = computed(() => creativeConfig.value.disableSmartCreative);

  return {
    disabled,
  };
}
